import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Badge, Button, Card, CardBody, Col, Input, Label, Row } from 'reactstrap';
import Breadcrumb from '../../components/common/breadcrumb';
import { getLoadPlan, getTransportProfiles } from './api';
import './devir-teslim.css';

// Operasyonlar > Grupaj İşlemleri > Yük Planlama (row 77): a groupage or a VIN list placed on a carrier profile of the
// chosen transport mode, within its decks' length / height / car limits and payload. Tallest cars first, each on the
// lowest deck that takes it; cars that do not fit are listed with the reason. Dimensions come from the model catalogue
// (sample values until OEM data is loaded).
const MODE = { KARAYOLU: 'Karayolu', DEMIRYOLU: 'Demiryolu', DENIZYOLU: 'Denizyolu' };

const DeckBar = ({ d }) => {
    const pct = Math.min(100, (d.used_length_mm / d.length_mm) * 100);
    return (
        <Card className="mb-2"><CardBody className="py-2">
            <div className="d-flex justify-content-between">
                <b>{d.name_tr}</b>
                <span className="dt-muted">yükseklik ≤ {d.max_height_mm} mm · {d.cars.length}/{d.max_cars} araç · {d.used_length_mm.toLocaleString('tr-TR')} / {d.length_mm.toLocaleString('tr-TR')} mm</span>
            </div>
            <div style={{ display: 'flex', border: '1px solid #c9cfdb', height: 46, marginTop: 6, background: '#f6f7fb' }}>
                {d.cars.map((c) => (
                    <div key={c.chassis_no} title={`${c.chassis_no} · ${c.length_mm}×${c.height_mm} mm · ${c.weight_kg} kg`}
                        style={{ width: `${(c.length_mm / d.length_mm) * 100}%`, marginRight: 2, background: '#15287c', color: '#fff', fontSize: 11, padding: '3px 4px', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                        {c.model}<br />{c.chassis_no.slice(-6)}
                    </div>
                ))}
            </div>
            <div className="dt-muted mt-1">Doluluk %{pct.toFixed(0)}</div>
        </CardBody></Card>
    );
};

const YukPlanlama = () => {
    const [profiles, setProfiles] = useState([]);
    const [profile, setProfile] = useState('');
    const [groupage, setGroupage] = useState('');
    const [vins, setVins] = useState('');
    const [plan, setPlan] = useState(null);
    useEffect(() => {
        getTransportProfiles().then((p) => { setProfiles(p); if (p.length) setProfile(p.find((x) => x.code === 'TIR_OTO')?.code || p[0].code); })
            .catch((e) => toast.error(e?.response?.data?.error || 'Taşıma profilleri alınamadı'));
    }, []);
    const run = () => getLoadPlan({ profile_code: profile, groupage_no: groupage.trim(), chassis_nos: vins.split(/[\s,;]+/).filter(Boolean) })
        .then(setPlan).catch((e) => { setPlan(null); toast.error(e?.response?.data?.error || 'Plan hazırlanamadı'); });
    const prof = profiles.find((p) => p.code === profile);
    return (
        <div>
            <Breadcrumb parent="Grupaj İşlemleri" current="Yük Planlama" />
            <Card><CardBody>
                <Row>
                    <Col md="4"><Label>Taşıma modu / taşıyıcı</Label>
                        <Input type="select" value={profile} onChange={(e) => setProfile(e.target.value)}>
                            {profiles.map((p) => <option key={p.code} value={p.code}>{MODE[p.mode]} — {p.name_tr}</option>)}
                        </Input>
                        {prof && <div className="dt-muted mt-1">{prof.note} · en çok {prof.max_cars} araç, {prof.max_payload_kg.toLocaleString('tr-TR')} kg · araç arası {prof.gap_mm} mm
                            · katlar: {prof.decks.map((d) => `${d.name_tr} ${d.length_mm / 1000} m / ≤${d.max_height_mm} mm`).join(', ')}</div>}
                    </Col>
                    <Col md="3"><Label>Grupaj no</Label><Input value={groupage} placeholder="S2026…" onChange={(e) => setGroupage(e.target.value)} /></Col>
                    <Col md="4"><Label>veya şase listesi</Label>
                        <Input type="textarea" rows={3} value={vins} placeholder="Her satıra bir VIN" onChange={(e) => setVins(e.target.value.toUpperCase())} /></Col>
                    <Col md="1" className="d-flex align-items-end"><Button color="primary" onClick={run}>Planla</Button></Col>
                </Row>
            </CardBody></Card>
            {plan && (
                <>
                    <Row className="mb-2">
                        {[['Yerleşen araç', `${plan.placed_cars} / ${plan.placed_cars + plan.unplaced.length}`],
                            ['Toplam ağırlık', `${plan.total_weight_kg.toLocaleString('tr-TR')} / ${plan.profile.max_payload_kg.toLocaleString('tr-TR')} kg`],
                            ['Kat uzunluğu kullanımı', `%${plan.length_use_pct}`]].map(([t, v]) => (
                            <Col md="4" key={t}><Card><CardBody className="py-3"><div className="dt-muted">{t}</div><h4 className="mb-0">{v}</h4></CardBody></Card></Col>
                        ))}
                    </Row>
                    {plan.decks.map((d) => <DeckBar key={d.deck_no} d={d} />)}
                    {plan.unplaced.length > 0 && (
                        <Card><CardBody>
                            <h6>Sığmayan araçlar</h6>
                            <table className="ct-table"><thead><tr><th>VIN</th><th>Model</th><th>Ölçü (U×Y, mm)</th><th>Neden</th></tr></thead>
                                <tbody>{plan.unplaced.map((c) => (
                                    <tr key={c.chassis_no}><td><b>{c.chassis_no}</b></td><td>{c.brand} {c.model}</td>
                                        <td>{c.length_mm ? `${c.length_mm}×${c.height_mm}` : '—'}</td><td><Badge color="warning">{c.reason}</Badge></td></tr>
                                ))}</tbody></table>
                        </CardBody></Card>
                    )}
                    <div className="dt-muted">Model ölçüleri örnek değerdir; OEM verisi yüklenince güncellenir.</div>
                </>
            )}
        </div>
    );
};

export default YukPlanlama;
